$(document).ready(function(){
  function view_button() {
   setTimeout(function() {
      $(".cart-drawer__content .for-scrl-div .cart-item-upsells .product-block .product-info").each(function() {
        var product_link = $(this).find(".product-link").attr("href");
        if ($(this).parent().find(".view_button").length === 0) {
          $(this).after(`<div class="view_button"><a href="${product_link}"> View product</a></div>`);
        }
      });
    }, 1000); 
  }

  $(document).on("theme:open-cart-drawer", function() {
    view_button();
    setTimeout(function(){
      view_button();
    }, 1000);
  });
  
  $(document).on("theme:cartchanged", function() {
    view_button();
    setTimeout(function(){
      view_button();
    }, 1000);
  });


  // account login script start
 $(".account-login-popup").click(function(){
    $(".cart-member-club .login-member").trigger("click"); 
  });
  // account login script end
  
});

// start script for popup after 10 sec show 
if (!sessionStorage.getItem('popupShown')) {
    setTimeout(function() {
        // Add the classes to trigger the popup
        document.querySelector('.cart-member-club').classList.add('active');
        document.querySelector('body').classList.add('popup-open');
       document.querySelector('[data-section-type="header"]').classList.add('hidden-visibility');

        // Store the fact that the popup has been shown
        sessionStorage.setItem('popupShown', 'true');
    }, 30000);
}
// end script for popup after 10 sec show 